/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { readTarget } from "cms/documents/document/helpers";
import { AsList } from "cms/documents/document/as-list";

const DocumentStyleBullet = (props) => {

    const { document, options } = props || {};
    const targetData = readTarget(options);
    const { target } = targetData || {};
    const asList = true;

    return (
        <Fragment>
            {document &&
                <AsList asList={asList}>
                    <a className="document-display-link"
                        href={document.url}
                        target={target}
                    >
                        <div className='document-display-text'>
                            <div>
                                {document.title}
                            </div>
                        </div>
                    </a>
                </AsList>
            }
        </Fragment>
    );
};

export { DocumentStyleBullet };
